var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-card",
    { staticClass: "m-0", attrs: { "no-body": "" } },
    [
      _vm.cardHeader ? _c("b-card-header", [_vm._t("header")], 2) : _vm._e(),
      _vm._v(" "),
      _c("b-card-body", [_vm._t("body")], 2),
      _vm._v(" "),
      _c("b-card-footer", [_vm._t("footer")], 2),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }